<template>
  <div>
    <config-title title="Definições"></config-title>
    <update-password></update-password>
    <update-pin></update-pin>
    <section-delete-account></section-delete-account>
    <delete-account></delete-account>
    <modal-update-pin></modal-update-pin>
  </div>
</template>

<script>
import Title from "../geral/Title";
import UpdatePassword from "./config/UpdatePassword";
import SectionDeleteAccount from "./config/SectionDeleteAccount";
import DeleteAccount from "../../tools/DeleteAccount";
import UpdatePin from "@/components/dashboard/client/config/UpdatePin";
import ModalUpdatePin from "@/components/dashboard/client/config/ModalUpdatePin";

export default {
  name: "Config",
  components: {
    ModalUpdatePin,
    UpdatePin,
    DeleteAccount,
    SectionDeleteAccount,
    UpdatePassword,
    "config-title": Title
  }
};
</script>

<style scoped></style>
